export const initialErrors = {
  cpf: 'Required',
  phone: 'Required',
  birth_date: 'Required',
};

export const initialErrorsMinimal = {
  phone: 'Required',
};
